import { network } from 'services/network';

import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const createMultipleReportNewTags = (params: Params): Promise<QueryResponse> => {
    return network.post('api/bo/reporting/addNewTags', params);
};

type Params = string[];

export interface QueryResponse {
    data: Tag[];
}
